/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBrandBing = createReactComponent("outline", "brand-bing", "IconBrandBing", [["path", { "d": "M5 3l4 1.5v12l6 -2.5l-2 -1l-1 -4l7 2.5v4.5l-10 5l-4 -2z", "key": "svg-0" }]]);

export { IconBrandBing as default };
//# sourceMappingURL=IconBrandBing.mjs.map
